import '@LegacyJS/core';
import '@LegacyJS/components/gallery-dialog.opener';
import '@LegacyJS/components/in-app-purchases';
import '@LegacyJS/components/browser-helper';
import '@LegacyJS/components/toggle-button';
import {tryStreamPollingFastPath} from '@Libraries/polling-ajax.library';
import {rememberRequestedAuthViewFromUrl} from '@Libraries/requested-auth-view.library';
import {initDynamicallyLoadedBundlesNeededOnAllPages} from '@Utils/dynamic-bundle-load.util';

// Register the SSE fast-path helper so legacy-JS core.js can call it without
// needing an ES module import.  core.js reads this as window.PMW.tryStreamPollingFastPath.
window.PMW.tryStreamPollingFastPath = tryStreamPollingFastPath;


document.addEventListener('DOMContentLoaded', function () {
  initDynamicallyLoadedBundlesNeededOnAllPages();
  rememberRequestedAuthViewFromUrl();
});